import API, { defaultHeaders } from '../';

const changePassword = async (payload = {}) => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}/user/change-password`, {
    method: 'put',
    headers,
    body: JSON.stringify(payload),
  });
};

export default changePassword;
